import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
// Inter, self-hosted. It was loaded from fonts.googleapis.com, which put every visitor's IP in
// front of Google before any consent gesture — on the login page included — and made the auth
// screens depend on a third party being up. The VARIABLE face also fixes what the CDN query got
// wrong: it asked for 400;500;600 while `font-bold` and `font-extrabold` render 700/800,
// so every page title, the wordmark and every KPI number was browser-synthesised faux bold
// (41 `font-bold` and 2 `font-extrabold`, counted).
import '@fontsource-variable/inter'
// …and the italic axis. 21 places use `italic`, including a figure on the invoicing screen; the
// upright faces alone would leave every one of them browser-synthesised, which is the same class
// of defect as the missing 700 weight, one axis over.
import '@fontsource-variable/inter/wght-italic.css'
import './globals.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
